import React, { useState, useEffect, useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Bookmark as BookmarkIcon, BookmarkBorder as BookmarkBorderIcon } from '@mui/icons-material';
import { httpGet, httpPost, httpDelete } from '../lib/http';

export default function BookmarkButton({ userId, pathId, subjectId, topicId, size = 'medium' }) {
  const [bookmarked, setBookmarked] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkBookmark = useCallback(async () => {
    if (!userId || !topicId) return;

    try {
      const res = await httpGet(
        `/api/users/${encodeURIComponent(userId)}/bookmarks?topicId=${encodeURIComponent(topicId)}`
      );
      
      if (res && res.ok) {
        const data = await res.json();
        const bookmarks = data.bookmarks || data || [];
        setBookmarked(Array.isArray(bookmarks) && bookmarks.length > 0);
      }
    } catch (err) {
      console.error('Error checking bookmark:', err);
    }
  }, [userId, topicId]);

  useEffect(() => {
    checkBookmark();
  }, [checkBookmark]);

  async function toggleBookmark() {
    if (!userId || !topicId || loading) return;

    setLoading(true);
    try {
      if (bookmarked) {
        // Remove bookmark
        const res = await httpDelete(
          `/api/users/${encodeURIComponent(userId)}/bookmarks/${encodeURIComponent(topicId)}`
        );
        
        if (res && res.ok) {
          setBookmarked(false);
        }
      } else {
        // Add bookmark
        const payload = {
          pathId,
          subjectId,
          topicId,
          createdAt: new Date().toISOString()
        };
        
        const res = await httpPost(
          `/api/users/${encodeURIComponent(userId)}/bookmarks`,
          payload
        );
        
        if (res && res.ok) {
          setBookmarked(true);
        }
      }
    } catch (err) {
      console.error('Error toggling bookmark:', err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Tooltip title={bookmarked ? 'Remove bookmark' : 'Bookmark this topic'}>
      <IconButton
        size={size}
        onClick={(e) => {
          e.stopPropagation();
          toggleBookmark();
        }}
        disabled={loading}
        color={bookmarked ? 'primary' : 'default'}
      >
        {bookmarked ? <BookmarkIcon /> : <BookmarkBorderIcon />}
      </IconButton>
    </Tooltip>
  );
}
